import React from 'react';
import { Box, Chip } from '@mui/material';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

export const ColumnsAddedChip = (props) => {
  const { columns=[], deleteCol } = props
  return (
    <Box style={{
      display: 'flex',
      gap: 8,
      alignItems:'center',
      flexWrap: 'wrap',
      margin: '48px auto'
    }}
    
    >
      {
        columns.map((item, idx) => (
          <Chip color="primary" key={`${item.toLowerCase()}_${idx}`} variant="outlined" label={item} onDelete={() => deleteCol(item)}
          deleteIcon={<HighlightOffIcon />}
          />
        ))
      }
    </Box>
  )
}
